// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Zm3C","info":"PatientInfo_info__344I4"};